import { Formatter } from "utils/formatters";

interface Props {
  cancellationPoliciesStartDate: string;
  cancellationValue: number;
  broker_selling_price: number;
}

const renderNoRefundMessage = (): JSX.Element => (
  <span className="md:font-medium text-center text-lg leading-6 text-neutral-700 dark:text-white mb-4">
    Sem reembolso.
  </span>
);

const renderRefundMessage = (startDate: string, value: number): JSX.Element => (
  <>
    <p className="text-[15px] text-center font-medium leading-6 text-neutral-700 dark:text-white mb-4 break-words pl-[40px] pr-[40px] mt-[13px]">
      Atenção, ao confirmar o cancelamento, será aplicada a multa conforme a
      política de cancelamento do hotel:
    </p>

    <span className="md:font-medium text-center text-lg leading-6 text-neutral-700 dark:text-white mb-4">
      A partir de {Formatter.prettyDateBRFormated(startDate)} multa de {value}{" "}
      ViroCash.
    </span>
  </>
);

export const getCancellationMessage = ({
  cancellationPoliciesStartDate,
  cancellationValue,
  broker_selling_price,
}: Props): JSX.Element | null => {
  const cancellationDate = new Date(cancellationPoliciesStartDate);
  const currentDate = new Date();

  if (cancellationDate > currentDate) {
    return null;
  }

  if (cancellationDate < currentDate) {
    if (cancellationValue >= broker_selling_price) {
      return renderNoRefundMessage();
    }
    return renderRefundMessage(
      cancellationPoliciesStartDate,
      cancellationValue
    );
  }

  return renderNoRefundMessage();
};
